export const isLanguageActive = (currentLanguage: string, targetCode: string) => {
  return currentLanguage.startsWith(targetCode);
};
